import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { GLOBAL } from '../../app/global';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ParametroService {

  urlParametro: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  
  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-08
   * @param httpClient
   */
  constructor(
    public httpClient:HttpClient
  ) {
    this.urlParametro = GLOBAL.URL_BASE+'sicaParametros';
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-10
   * @param codigo
   */
  getSicaParametroByCodigo(codigo:string):Observable<any>{
    return this.httpClient.get(this.urlParametro+'/getSicaParametroByCodigo/'+codigo, this.httpOptions);
  }

  /**
   * @author Freddy Sebastián García Victoria
   * @version 2018-10-10
   * @param codigo
   */
  getSicaParametrosLikeCodigo(codigo:string):Observable<any>{
    return this.httpClient.get(this.urlParametro+'/getSicaParametroLikeCodigo/'+codigo, this.httpOptions);
  }
}
